import quickpopup from 'quickpopup'
import * as templates from './popup-templates'


export default performAction = (action, card)->
	switch action
		when 'open-qr-code' then openQrCode(card)
		when 'share-card' then shareCard(card)
		when 'add-to-home' then addToHome(card)
		when 'open-zelle-popup' then openZellePopup(card)
		when 'open-paypal-popup' then openPaypalPopup(card)


qrcode = null
openQrCode = (card)->
	qrcode ?= quickpopup templates.qrcode.spawn(data:{qrcode:card.qrcode})
	qrcode.open()


athpopup = null
addToHome = (card)->
	athpopup ?= quickpopup templates.addToHome.spawn()
	athpopup.open()


zellepopup = null
openZellePopup = (card)->
	point = card.contactPoints.find ({type})-> type is 'zelle'
	zellepopup ?= quickpopup templates.zellepopup.spawn(data:{zelle:point.value})
	zellepopup.open()


paypalpopup = null
openPaypalPopup = (card)->
	point = card.contactPoints.find ({type})-> type is 'paypal'
	paypalpopup ?= quickpopup templates.paypalpopup.spawn(data:{paypal:point.value})
	paypalpopup.open()


shareCard = (card)->
	if not navigator.share
		return alert "Your browser doesn't support sharing, please try from a different browser."

	try
		await navigator.share
			title: "#{card.name} | Digital Business Card"
			text: ''
			url: window.location.href
	catch err
		# alert "Sharing has failed. Please try again later."
		console.log err


